// @flow
import React, { useContext, useState } from 'react';

import ReactAppContext from 'Context/ReactAppContext';
import { AsyncLoader } from 'Components/frameworks/async-loader/AsyncLoader';
import { ProductsGrid } from 'Components/widgets/products-grid/ProductsGrid';
import type {
  FetchProductsParamsType,
  CMSProps,
} from 'Client/cms/toolkit/products-grid/productsGrid.resolver';
import { type ProductsGridDescriptorProps } from 'Client/cms/toolkit/products-grid/productsGrid.resolver';
import { grid, type ProductProps } from 'Components/widgets/product/Product.utils';

type AsyncProductsGridProps = {
  ...$Exact<CMSProps>,
  productIds: $ReadOnlyArray<string>,
  offer?: Offer,
  productsMapper: (props: ProductsGridDescriptorProps) => $ReadOnlyArray<ProductProps>,
  asyncPropsMapper: (
    initialProps: { products: Array<ProductProps> },
    moreProducts: Array<ProductProps>,
  ) => *,
  fetchProducts: FetchProductsParamsType => *,
};

export function AsyncProductsGrid(props: AsyncProductsGridProps) {
  const appContext = useContext(ReactAppContext);
  const [isLoading, setIsLoading] = useState(false);
  const { productIds = [], offer, productsMapper, asyncPropsMapper, fetchProducts } = props;

  const fetchMore = async () => {
    const remainingProductIds = productIds.slice(grid.desktop);

    setIsLoading(true);

    const { products } = await fetchProducts({
      appContext,
      productIds: remainingProductIds,
      offerId: offer ? offer.id : undefined,
      props,
    });

    setIsLoading(false);

    // $FlowFixMe soz, i'm just refactoring, before me flow didn't understand the typings
    return productsMapper({ ...props, products });
  };

  return (
    <AsyncLoader asyncPropsMapper={asyncPropsMapper} fetchData={fetchMore}>
      <ProductsGrid {...props} offer={offer} isLoading={isLoading} />
    </AsyncLoader>
  );
}
